module.exports = __webpack_public_path__ + "media/veo31-demo.9a5b6036.mp4";